import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

const BFF_BASE_URL = window.__ENV__.BFF_URL;
const OK = 200;

// Action names
const ACTION_NAME_PREFIX = 'ACTION_TERMINATE_CIAM_SESSION';
export const REQUEST_ACTION_NAME = `${ACTION_NAME_PREFIX}_REQUEST`;
export const RESPONSE_ACTION_NAME = `${ACTION_NAME_PREFIX}_RESPONSE`;
export const ERROR_ACTION_NAME = `${ACTION_NAME_PREFIX}_ERROR`;

/**
 * Terminates CIAM session for a given member.
 * @param {object} logger
 */
export const TerminateCIAMSession = () => {
    return async (dispatch, getState, { logger }) => {
        const { jwt, sessionCorrelationId } = getState().Authentication;
        const transactionId = logger.generateGuid();
        const TERMINATE_CIAM_PATH = `${BFF_BASE_URL}/identity/v3/member/session/terminate`;
        dispatch({ type: REQUEST_ACTION_NAME });

        logger.info(`${ACTION_NAME_PREFIX}: Terminating CIAM session for a member.`, {
            correlation: { transactionId },
        });

        // Call BFF terminate given CIAM session
        const response = await fetch(TERMINATE_CIAM_PATH, {
            method: 'POST',
            headers: {
                'mli-correlation-id': transactionId,
                'mli-session-correlation-id': sessionCorrelationId,
                'mli-channel': 'web',
                'gb-authorization': jwt,
            },
        });
        const responseBody = await response.json();

        if (response.status !== OK) {
            const { code, message } = responseBody;
            logger.critical(
                `${ACTION_NAME_PREFIX}: Failure when terminating CIAM session for a member. Code: ${code} Reason: ${message}`,
                { correlation: { transactionId } }
            );
            return dispatch({
                type: ERROR_ACTION_NAME,
                code,
                message,
            });
        }

        return dispatch({
            type: RESPONSE_ACTION_NAME,
            success: true,
        });
    };
};

export const requestReducer = produce((state) => {
    state.MemberData.isTerminatingCIAMSession = true;
});

export const responseReducer = produce((state) => {
    state.MemberData.isTerminatingCIAMSession = false;
});

export const errorReducer = produce((state, action) => {
    state.MemberData.isTerminatingCIAMSession = false;
    state.Errors.terminateCIAMSession.hasError = true;
    state.Errors.terminateCIAMSession.code = action.code;
    state.Errors.terminateCIAMSession.message = action.message;
});

registerReducer(REQUEST_ACTION_NAME, requestReducer);
registerReducer(RESPONSE_ACTION_NAME, responseReducer);
registerReducer(ERROR_ACTION_NAME, errorReducer);
